<template>
  <div class="download-dialog common-dialog">
    <div class="dialog-content">
      <p class="text">Play the podcast on Podbean</p>
      <p class="title">{{ setting.podcastTitle }}</p>
      <div class="app-download">
        <a
          class="download-app-btn"
          :href="episode.playStopShareLink"
          target="_blank"
        >
          <icon-small-podbean-logo/>
          <span class="line"></span>
          <span class="btn-text">Listen on <br> Podbean app</span>
        </a>
      </div>
    </div>
    <a v-if="setting.pbad" class="podbean-logo"
       target="_blank"
       href="http://www.podbean.com?utm_campaign=pb_web_audio_player&utm_medium=app_download&utm_source=pb_web_player"
    >
      <icon-podbean-logo></icon-podbean-logo>
    </a>
    <button class="close" @click="close">
      <icon-close></icon-close>
    </button>
  </div>
</template>

<script>
    import {MUTATION_UPDATE} from "@/store/mutations";
    import IconClose from "./icons/IconClose";
    import IconPodbeanLogo from "./icons/IconPodbeanLogo";
    import {mapGetters, mapState} from "vuex";
    import IconSmallPodbeanLogo from "./icons/IconSmallPodbeanLogo";

    export default {
  name: "AppDownload",
  components: {IconSmallPodbeanLogo, IconPodbeanLogo, IconClose },
  computed: {
    ...mapState(["setting"]),
    ...mapGetters(['episode'])
  },
  methods: {
    close() {
      this.$store.commit(MUTATION_UPDATE, ["showAppDownloadStatus", 2]);
    }
  }
};
</script>

<style lang="scss" scoped>
.download-dialog {
  position: absolute;
  left: 0;
  top: 0;
  background: #f6f6f6;
  width: 100%;
  z-index: 999999;
  bottom: 0;
  height: 100%;
  .dialog-content {
    text-align: center;
    right: 0;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 105px;
  }
  .app-download {
    .ios-img {
      margin-right: 3px;
    }
    img {
      width: 110px;
    }
  }
  p {
    font-size: 14px;
    margin-bottom: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .title{
    padding-bottom: 7px;
    font-weight: 600;
    padding-right: 15px;
    padding-left: 15px;
  }
}
</style>
